import React, { useState } from 'react';
import Hero from '../components/Hero';
import styles from './Archive.module.css';

interface ArchiveItem {
  year: number;
  title: string;
  participants: number;
  companies: number;
}

interface GalleryPhoto {
  id: number;
  alt: string;
  src?: string;
}

interface VideoData {
  src: string;
}

const archiveItems: ArchiveItem[] = [
  {
    year: 2026,
    title: 'Rückblick: DUOday 2026 in Hannover – Gemeinsam Inklusion erleben und Zukunft gestalten',
    participants: 125,
    companies: 149,
  },
  {
    year: 2025,
    title: 'Rückblick: DUOday 2025 in Hannover – Ein erfolgreicher Start für mehr Inklusion',
    participants: 65,
    companies: 93,
  },
];

const galleryPhotosByYear: Record<number, GalleryPhoto[]> = {
    2026: [
    { id: 1, alt: 'DUOday 2026 - Foto 1', src: '/Archive/2026/0002.jpg' },
    { id: 2, alt: 'DUOday 2026 - Foto 2', src: '/Archive/2026/0010.jpg' },
    { id: 3, alt: 'DUOday 2026 - Foto 3', src: '/Archive/2026/0016.jpg' },
    { id: 4, alt: 'DUOday 2026 - Foto 4', src: '/Archive/2026/0017.jpg' },
    { id: 5, alt: 'DUOday 2026 - Foto 5', src: '/Archive/2026/0024.jpg' },
    { id: 6, alt: 'DUOday 2026 - Foto 6', src: '/Archive/2026/0030.jpg' },
    { id: 7, alt: 'DUOday 2026 - Foto 7', src: '/Archive/2026/0031.jpg' },
    { id: 8, alt: 'DUOday 2026 - Foto 8', src: '/Archive/2026/0032.jpg' },
    { id: 9, alt: 'DUOday 2026 - Foto 9', src: '/Archive/2026/0038.jpg' },
    { id: 10, alt: 'DUOday 2026 - Foto 10', src: '/Archive/2026/IMG_0564.jpg' },
    { id: 11, alt: 'DUOday 2026 - Foto 11', src: '/Archive/2026/IMG_3528.jpeg' },
    { id: 12, alt: 'DUOday 2026 - Foto 12', src: '/Archive/2026/IMG_9219.jpeg' },
    { id: 13, alt: 'DUOday 2026 - Foto 13', src: '/Archive/2026/IMG_9223.jpeg' },
    { id: 14, alt: 'DUOday 2026 - Foto 14', src: '/Archive/2026/20260527_philippsonnack_enercity_DUODay%202026_2.jpg' },
    { id: 15, alt: 'DUOday 2026 - Foto 15', src: '/Archive/2026/20260527_philippsonnack_enercity_DUODay%202026_22.jpg' },
    { id: 16, alt: 'DUOday 2026 - Foto 16', src: '/Archive/2026/20260527_philippsonnack_enercity_DUODay%202026_4.jpg' },
    { id: 17, alt: 'DUOday 2026 - Foto 17', src: '/Archive/2026/20260527_philippsonnack_enercity_DUODay%202026_49.jpg' },
    { id: 18, alt: 'DUOday 2026 - Foto 18', src: '/Archive/2026/20260527_philippsonnack_enercity_DUODay%202026_53.jpg' },
  ],
    2025: [
    { id: 1, alt: 'DUOday 2025 - Foto 1', src: '/Archive/2025/DUO_Day-017.jpg' },
    { id: 2, alt: 'DUOday 2025 - Foto 2', src: '/Archive/2025/DUO_Day-040.jpg' },
    { id: 3, alt: 'DUOday 2025 - Foto 3', src: '/Archive/2025/DUO_Day-067.jpg' },
    { id: 4, alt: 'DUOday 2025 - Foto 4', src: '/Archive/2025/DUO_Day-072.jpg' },
    { id: 5, alt: 'DUOday 2025 - Foto 5', src: '/Archive/2025/DUO_Day-073.jpg' },
    { id: 6, alt: 'DUOday 2025 - Foto 6', src: '/Archive/2025/DuoDay-032.jpg' },
    { id: 7, alt: 'DUOday 2025 - Foto 7', src: '/Archive/2025/DuoDay-039.jpg' },
    { id: 8, alt: 'DUOday 2025 - Foto 8', src: '/Archive/2025/DuoDay-041.jpg' },
    { id: 9, alt: 'DUOday 2025 - Foto 9', src: '/Archive/2025/DuoDay-046.jpg' },
    { id: 10, alt: 'DUOday 2025 - Foto 10', src: '/Archive/2025/DuoDay-057.jpg' },
    { id: 11, alt: 'DUOday 2025 - Foto 11', src: '/Archive/2025/DuoDay-077.jpg' },
    { id: 12, alt: 'DUOday 2025 - Foto 12', src: '/Archive/2025/DuoDay-095.jpg' },
    { id: 13, alt: 'Kevin und Torben', src: '/Archive/2025/KevinUndTorben.jpg' },
  ],
};

const videosByYear: Record<number, VideoData> = {
  2026: {
    src: '/videos/archive/DUOday%202026.mp4',
  },
  2025: {
    src: '/videos/archive/ec_duoday2025_2_1920x1080px_untertitel_04_720.mp4',
  },
};

const mediaCoverageByYear: Record<number, GalleryPhoto[]> = {
  2026: [
    { id: 5, alt: 'Medienecho 2026 - Fahrgastfernsehen', src: '/Archive/2026/Slide17.jpg' },
    { id: 6, alt: 'Medienecho 2026 - Homepage Stadt Langenhagen', src: '/Archive/2026/Slide18.jpg' },
    { id: 7, alt: 'Medienecho 2026 - Homepage Stadt Laatzen', src: '/Archive/2026/Slide19.jpg' },
    { id: 8, alt: 'Medienecho 2026 - Homepage Stadt Pattensen', src: '/Archive/2026/Slide20.jpg' },
    { id: 9, alt: 'Medienecho 2026 - Homepage Stadt Garbsen', src: '/Archive/2026/Slide21.jpg' },
    { id: 10, alt: 'Medienecho 2026 - Homepage Stadt Barsinghausen', src: '/Archive/2026/Slide22.jpg' },
    { id: 11, alt: 'Medienecho 2026 - Homepage Stadt Seelze', src: '/Archive/2026/Slide23.jpg' },
  ],
  2025: [
    { id: 1, alt: 'bips Zeitschrift der Hannoverschen Werkstätten 2/2025 - Titelseite', src: '/Archive/2025/Bild (5).png' },
    { id: 2, alt: 'bips Zeitschrift - Seite 4: Einfach mal raus - und sehen, was möglich ist', src: '/Archive/2025/Bild (6).png' },
    { id: 3, alt: 'bips Zeitschrift - Seite 5: Organisiert wurde der Tag von enercity', src: '/Archive/2025/Bild (7).png' },
    { id: 4, alt: 'bips Zeitschrift - Seite 6: Was ist der DUOday?', src: '/Archive/2025/Bild (8).png' },
    { id: 5, alt: 'bips Zeitschrift - Seite 7: 4 DUOs, 8 Stimmen', src: '/Archive/2025/Bild (9).png' },
    { id: 6, alt: 'bips Zeitschrift - Seite 8: Tim Touati und Sven Schubert im Kundencenter', src: '/Archive/2025/Bild (10).png' },
    { id: 7, alt: 'bips Zeitschrift - Seite 9: Stefan Lindner und Fabian Wappelt', src: '/Archive/2025/Bild (11).png' },
    { id: 8, alt: 'Medienecho 2025 - DUOday in Hannovers ÖPNV', src: '/Archive/2025/Slide14.jpg' },
    { id: 9, alt: 'Medienecho 2025 - Radio Handicap on Air', src: '/Archive/2025/Slide15.jpg' },
    { id: 10, alt: 'Medienecho 2025 - Artikel in lokalen Online-Medien', src: '/Archive/2025/Slide16.jpg' },
  ],
};

export default function Archive() {
  const [selectedPhoto, setSelectedPhoto] = useState<GalleryPhoto | null>(null);
  const [selectedIndex, setSelectedIndex] = useState<number>(-1);
  const [activePhotoList, setActivePhotoList] = useState<GalleryPhoto[]>([]);
  const [selectedYear, setSelectedYear] = useState<number>(2026);

  const currentGalleryPhotos = galleryPhotosByYear[selectedYear] || [];
  const currentMediaCoverage = mediaCoverageByYear[selectedYear] || [];

  const handlePhotoClick = (photo: GalleryPhoto, list: GalleryPhoto[]) => {
    setSelectedPhoto(photo);
    setActivePhotoList(list);
    const index = list.findIndex(p => p.id === photo.id);
    setSelectedIndex(index);
  };

  const handleCloseModal = () => {
    setSelectedPhoto(null);
    setSelectedIndex(-1);
  };

  const handleNextPhoto = () => {
    if (selectedIndex < activePhotoList.length - 1) {
      const nextPhoto = activePhotoList[selectedIndex + 1];
      setSelectedPhoto(nextPhoto);
      setSelectedIndex(selectedIndex + 1);
    }
  };

  const handlePreviousPhoto = () => {
    if (selectedIndex > 0) {
      const prevPhoto = activePhotoList[selectedIndex - 1];
      setSelectedPhoto(prevPhoto);
      setSelectedIndex(selectedIndex - 1);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      handleCloseModal();
    }
    if (e.key === 'ArrowRight') {
      handleNextPhoto();
    }
    if (e.key === 'ArrowLeft') {
      handlePreviousPhoto();
    }
  };
  return (
    <section className={styles.archive} onKeyDown={handleKeyDown} tabIndex={0}>
      <Hero
        image="../DUO_Day-111-klein.jpg"
      />

      {/* Jahresauswahl */}
      <div className={styles.yearSelector}>
        <div className={styles.yearButtons}>
          {[...archiveItems].sort((a, b) => a.year - b.year).map((item) => (
            <button
              key={item.year}
              className={`${styles.yearButton} ${selectedYear === item.year ? styles.yearButtonActive : ''}`}
              onClick={() => setSelectedYear(item.year)}
            >
              {item.year}
            </button>
          ))}
        </div>
      </div>

      {/* Modal für vergrößerte Bilder */}
      {selectedPhoto && (
        <div className={styles.modal} onClick={handleCloseModal} onKeyDown={handleKeyDown} tabIndex={0}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <button 
              className={styles.modalClose} 
              onClick={handleCloseModal}
              aria-label="Schließen"
            >
              ✕
            </button>

            {/* Linker Pfeil */}
            {selectedIndex > 0 && (
              <button 
                className={styles.modalPrevButton}
                onClick={handlePreviousPhoto}
                aria-label="Vorheriges Foto"
              >
                ‹
              </button>
            )}

            {/* Bild */}
            <img 
              src={selectedPhoto.src} 
              alt={selectedPhoto.alt}
              className={styles.modalImage}
            />

            {/* Rechter Pfeil */}
            {selectedIndex < activePhotoList.length - 1 && (
              <button 
                className={styles.modalNextButton}
                onClick={handleNextPhoto}
                aria-label="Nächstes Foto"
              >
                ›
              </button>
            )}
          </div>
        </div>
      )}

      {archiveItems.map((item) => (
        <article key={item.year} className={styles.archiveItem} style={{ display: selectedYear === item.year ? 'block' : 'none' }}>
          {/* ✅ H1 – genau einmal */}
          <h1 className={styles.pageTitle}>{item.title}</h1>

          {/* Meta-Infos */}
          <div className={styles.cardStats}>
            <div className={styles.stat}>
              <span className={styles.statNumber}>{item.participants}</span>
              <span>erfolgreiche DUOs</span>
            </div>
            <div className={styles.stat}>
              <span className={styles.statNumber}>{item.companies}</span>
              <span>mögliche DUOs</span>
            </div>
          </div>

          {/* ===== Inhalt Jahr 2025 ===== */}
          {item.year === 2025 && (
            <>
              <div className={styles.introWithPoster}>
                <figure className={styles.poster}>
                  <a
                    className={styles.posterImageLink}
                    href="/Archive/2025/plakat.png"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="DUOday-Plakat 2025 in Originalgröße öffnen"
                  >
                    <img
                      src="/Archive/2025/plakat.png"
                      alt="Plakat zum DUOday am 21. Mai 2025"
                    />
                  </a>
                  <figcaption className={styles.posterCaption}>
                    <span>DUOday Hannover 2025</span>
                    <a href="/Archive/2025/plakat.png" target="_blank" rel="noreferrer">
                      Originalgröße öffnen
                    </a>
                  </figcaption>
                </figure>

                <div className={styles.introText}>
                  <p className={styles.leadParagraph}>
                    65 gebildete DUOs, 7 Unternehmen und Institutionen sowie 3
                    Werkstätten – der erste DUOday Hannover war ein voller Erfolg
                    und setzte ein starkes Zeichen für mehr Teilhabe in der
                    Arbeitswelt.
                  </p>

                  <p>
                    Am 21. Mai 2025 wurde in der Region Hannover erstmals der DUOday
                    durchgeführt. Was mit einer Idee begann, entwickelte sich innerhalb
                    weniger Monate zu einem beeindruckenden Gemeinschaftsprojekt, das
                    Menschen zusammenbrachte, neue Perspektiven eröffnete und den Grundstein
                    für eine nachhaltige inklusive Arbeitswelt legte.
                  </p>

                  <p>
                    Der DUOday bietet Menschen mit Behinderungen die Möglichkeit, einen
                    Tag lang gemeinsam mit einer Mitarbeiterin oder einem Mitarbeiter
                    eines Unternehmens den Arbeitsalltag kennenzulernen. Dabei geht es
                    nicht um ein Bewerbungsgespräch oder eine Leistungsbewertung, sondern
                    um Begegnungen auf Augenhöhe, gegenseitiges Kennenlernen und den Abbau
                    von Berührungsängsten.
                  </p>
                </div>
              </div>

              <h2>Die Idee kommt nach Hannover</h2>
              <p>
                Den Anstoß für den DUOday Hannover gab ein Netzwerktreffen der
                Schwerbehindertenvertretungen in Hamburg im Jahr 2024. Dort wurde
                das erfolgreiche Konzept vorgestellt und schnell war klar: Dieses
                Format soll auch nach Hannover kommen.
              </p>

              <p>
                Gemeinsam mit zahlreichen engagierten Partner:innen wurde der erste
                DUOday organisiert. Von Beginn an übernahmen enercity, die Landeshauptstadt
                Hannover und die Region Hannover die gemeinsame Schirmherrschaft und
                unterstützten die Initiative mit großem Engagement.
              </p>

              <h2>Ein starkes Netzwerk für mehr Inklusion</h2>
              <p>
                Bereits im ersten Jahr beteiligten sich:
                 <ul>
                  <li>7 Unternehmen und Institutionen</li>
                  <li>3 Werkstätten für Menschen mit Behinderungen</li>
                  <li>93 angebotene DUO-Plätze</li>
                  <li>65 erfolgreich gebildete DUOs</li>
                </ul> 
              </p>

              <p>
                Hinter jedem einzelnen DUO stand ein sorgfältiges Matching zwischen
                Unternehmen und Werkstätten. Ziel war es, Interessen, Fähigkeiten
                und Einsatzmöglichkeiten bestmöglich zusammenzubringen und so für beide
                Seiten einen gewinnbringenden Tag zu ermöglichen.
              </p>

              <h2>Begegnungen, die bewegen</h2>
              <p>
                Der DUOday 2025 zeigte eindrucksvoll, wie schnell Vorurteile verschwinden
                können, wenn Menschen miteinander ins Gespräch kommen.
              </p>

              <p>
                Für die Teilnehmenden bot sich die Chance, neue Berufsfelder kennenzulernen,
                Arbeitsabläufe zu erleben und wertvolle Kontakte zu knüpfen. Gleichzeitig
                konnten Unternehmen erleben, welche Potenziale, Motivation und Fähigkeiten 
                Menschen mit Behinderungen mitbringen.
              </p>

              <p>
                Viele DUO-Partner:innen berichteten im Anschluss, dass der gemeinsame Tag
                ihren Blick auf Inklusion nachhaltig verändert hat. Aus einem Kennenlernen
                entstanden neue Ideen, Praktika und der Wunsch, Inklusion dauerhaft stärker
                im eigenen Unternehmen zu verankern.
              </p>

              <h2>Ein gelungener Abschluss</h2>
              <p>
                Den feierlichen Abschluss bildete am 11. Juni 2025 die Abschlussveranstaltung
                bei enercity. Gemeinsam blickten Unternehmen, Werkstätten, DUO-Partner:innen
                und zahlreiche Gäste auf einen bewegenden ersten DUOday zurück.
              </p>

              <p>
                Die Veranstaltung machte deutlich, dass der DUOday weit mehr ist als ein 
                Aktionstag. Er schafft Begegnungen, baut Barrieren ab und eröffnet neue Chancen
                – für Menschen mit Behinderungen ebenso wie für Unternehmen.
              </p>

              <h2>Danke für den gelungenen Auftakt</h2>
              <p>
                Der erste DUOday Hannover wäre ohne das Engagement vieler Menschen nicht möglich gewesen.
              </p>
                Ein herzliches Dankeschön gilt allen Unternehmen, Werkstätten, Unterstützer:innen,
                Kooperationspartner:innen sowie den vielen engagierten Mitarbeitenden, die ihre 
                Arbeitsplätze geöffnet und den DUOday mit Leben gefüllt haben.
              <p>
                Ein besonderer Dank gilt unseren Schirmherr:innen – enercity, der Landeshauptstadt Hannover
                und der Region Hannover – für ihre Unterstützung und ihr Vertrauen in dieses neue Format.
              </p>

              <h2>Der Grundstein ist gelegt</h2>
              <p>
                Mit 65 gebildeten DUOs aus 93 möglichen Partnerschaften ist der DUOday Hannover erfolgreich
                gestartet. Die große Resonanz hat gezeigt, wie wichtig Begegnungen zwischen Menschen mit
                und ohne Behinderungen für eine inklusive Arbeitswelt sind.
              </p>
                
              <p>
                Der Erfolg des ersten DUOdays war gleichzeitig Motivation, das Projekt weiter auszubauen
                – mit noch mehr Unternehmen, noch mehr Werkstätten und noch mehr Menschen, die gemeinsam
                ein Zeichen für Vielfalt und Teilhabe setzen.
              </p>

              <p>
                Der Grundstein war gelegt – und die Erfolgsgeschichte des DUOday Hannover hatte begonnen. 💜
              </p>
            </>
          )}

          {/* ===== Inhalt Jahr 2026 ===== */}
          {item.year === 2026 && (
            <>
              <div className={styles.introWithPoster}>
                <figure className={styles.poster}>
                  <a
                    className={styles.posterImageLink}
                    href="/Archive/2026/plakat.png"
                    target="_blank"
                    rel="noreferrer"
                    aria-label="DUOday-Plakat 2026 in Originalgröße öffnen"
                  >
                    <img
                      src="/Archive/2026/plakat.png"
                      alt="Plakat zum DUOday am 20. Mai 2026"
                    />
                  </a>
                  <figcaption className={styles.posterCaption}>
                    <span>DUOday Hannover 2026</span>
                    <a href="/Archive/2026/plakat.png" target="_blank" rel="noreferrer">
                      Originalgröße öffnen
                    </a>
                  </figcaption>
                </figure>

                <div className={styles.introText}>
                  <p className={styles.leadParagraph}>
                    125 DUOs, 21 Unternehmen und Institutionen, 6 Werkstätten – der DUOday
                    2026 setzt ein starkes Zeichen für gelebte Inklusion in der Region Hannover.
                  </p>

                  <p>
                    Am 27. Mai 2026 fand der zweite DUOday in Hannover statt. Nach der erfolgreichen
                    Premiere im vergangenen Jahr ist die Initiative weiter gewachsen und hat
                    eindrucksvoll gezeigt, wie wertvoll Begegnungen auf Augenhöhe sind. Menschen mit
                    Behinderungen erhielten die Möglichkeit, gemeinsam mit Mitarbeitenden aus
                    Unternehmen, Verwaltungen und Institutionen einen Arbeitstag zu verbringen und
                    unterschiedliche Berufsfelder kennenzulernen. Gleichzeitig konnten Arbeitgebende
                    Potenziale entdecken, Berührungsängste abbauen und wertvolle Erfahrungen für eine
                    inklusive Arbeitswelt sammeln.
                  </p>
                </div>
              </div>

              <h2>Eine Erfolgsgeschichte wächst weiter</h2>
              <p>
                Der DUOday Hannover wurde 2025 von enercity initiiert und steht unter der 
                gemeinsamen Schirmherrschaft von enercity, der Landeshauptstadt Hannover und der
                Region Hannover.
              </p>

              <p>
                Im Jahr 2026 standen 149 mögliche DUOs zur Verfügung. Durch das intensive Matching
                zwischen Unternehmen und Werkstätten konnten daraus 125 DUOs gebildet werden. Damit
                wurde eine Matchingquote von rund 84 Prozent erreicht – ein hervorragendes Ergebnis,
                das eindrucksvoll zeigt, wie groß das Engagement aller Beteiligten für mehr 
                Inklusion ist.
              </p>

              <p>
                Möglich wurde dies durch das große Engagement zahlreicher Partner:innen. Insgesamt
                beteiligten sich in diesem Jahr:
                 <ul>
                  <li>21 Unternehmen und Institutionen</li>
                  <li>6 Werkstätten für Menschen mit Behinderungen</li>
                  <li>149 angebotene DUO-Plätze</li>
                  <li>125 erfolgreich gebildete DUOs</li>
                  <li>zahlreiche engagierte Mitarbeitende, die als DUO-Partner:innen einen Tag lang
                    ihre Arbeitswelt öffneten.</li>
                </ul> 
              </p>

              <h2>Begegnungen, die Perspektiven schaffen</h2>
              <p>
                Der DUOday lebt von persönlichen Begegnungen. Einen Tag lang wird gemeinsam gearbeitet,
                ausprobiert, gefragt, erklärt und gelacht. Dabei entstehen neue Eindrücke – auf beiden 
                Seiten.
              </p>

              <p>
                Für Menschen mit Behinderungen eröffnet der DUOday neue Einblicke in den allgemeinen
                Arbeitsmarkt und zeigt berufliche Möglichkeiten auf. Unternehmen erleben unmittelbar,
                welche Fähigkeiten, Talente und Motivation die Teilnehmenden mitbringen.
              </p>

              <p>
                Aus vielen Gesprächen wurde deutlich: Oft reicht ein gemeinsamer Arbeitstag aus, um 
                Vorurteile abzubauen und neue Chancen entstehen zu lassen. Aus einem ersten Kennenlernen 
                entstehen nicht selten langfristige Kontakte, Praktika oder sogar Beschäftigungsperspektiven. 
                Genau das macht den DUOday so besonders.
              </p>

              <p>
                Im Mittelpunkt standen die vielen persönlichen Geschichten und Erfahrungen der Teilnehmenden.
                Sie machten deutlich, dass Inklusion nicht nur ein gesellschaftlicher Auftrag ist, sondern 
                eine echte Chance für Unternehmen und Menschen gleichermaßen. Viele der entstandenen Kontakte 
                werden über den DUOday hinaus Bestand haben und bilden die Grundlage für weitere Praktika, 
                betriebliche Erprobungen oder sogar zukünftige Beschäftigungsverhältnisse.
              </p>

              <h2>Abschlussveranstaltung in der Region Hannover</h2>
              <p>
                Den feierlichen Abschluss bildete am 8. Juni 2026 die Abschlussveranstaltung im Haus der Region 
                Hannover. Gemeinsam blickten Unternehmen, Werkstätten, DUO-Partner:innen sowie zahlreiche Gäste 
                auf einen erfolgreichen Aktionstag zurück.
              </p>

              <p>
                Im Mittelpunkt standen die vielen persönlichen Geschichten und Erfahrungen der Teilnehmenden. 
                Sie machten deutlich, dass Inklusion nicht nur ein gesellschaftlicher Auftrag ist, sondern eine 
                echte Chance für Unternehmen und Menschen gleichermaßen. Viele der entstandenen Kontakte werden
                über den DUOday hinaus Bestand haben und bilden die Grundlage für weitere Praktika, betriebliche 
                Erprobungen oder sogar zukünftige Beschäftigungsverhältnisse.
              </p>

              <h2>Danke für dieses starke Zeichen</h2>
              <p>
                Ein herzliches Dankeschön gilt allen Unternehmen, Werkstätten, Unterstützer:innen sowie den vielen
                engagierten Mitarbeitenden, die den DUOday 2026 möglich gemacht haben.
              </p>
                Ein besonderer Dank gilt unseren Schirmherr:innen – enercity, der Landeshauptstadt Hannover und 
                der Region Hannover – sowie allen Kooperationspartner:innen, Werkstätten und Unternehmen, die den
                DUOday mit großem Engagement unterstützt haben.
              <p>
                Der Dank gilt aber vor allem den Menschen, die den DUOday mit Leben gefüllt haben: den Teilnehmenden,
                den DUO-Partner:innen und allen Mitarbeitenden, die ihre Arbeitsplätze geöffnet, Fragen beantwortet 
                und Begegnungen auf Augenhöhe ermöglicht haben.
              </p>

              <h2>Gemeinsam für eine inklusive Arbeitswelt</h2>
              <p>
                Der DUOday zeigt eindrucksvoll, dass Inklusion dann gelingt, wenn Menschen miteinander ins Gespräch 
                kommen und sich ohne Vorurteile begegnen. Ein gemeinsamer Arbeitstag kann Perspektiven verändern, 
                Talente sichtbar machen und Türen öffnen – für beide Seiten.
              </p>
                
              <p>
                Mit 125 gebildeten DUOs aus 149 möglichen Partnerschaften wurde 2026 ein starkes Ergebnis erzielt. 
                Gleichzeitig ist dies Motivation, den DUOday weiterzuentwickeln und künftig noch mehr Menschen 
                zusammenzubringen.
              </p>

              <p>
                Wir sehen uns beim DUOday 2027!
              </p>

              <h2>Der nächste DUOday Hannover findet am 26. Mai 2027 statt.</h2>
              <p>
                Schon heute freuen wir uns darauf, gemeinsam mit bestehenden und neuen Partner:innen den nächsten 
                Schritt zu gehen und noch mehr Menschen die Möglichkeit zu geben, berufliche Perspektiven kennenzulernen, 
                Vorurteile abzubauen und wertvolle Begegnungen zu erleben.
              </p>
                
              <p>
                Jedes gebildete DUO ist ein Schritt hin zu einer inklusiveren Arbeitswelt.
              </p>

              <p>
                Gemeinsam. Auf Augenhöhe. Für mehr Inklusion. 💜
              </p>
            </>
          )}

          {/* Video */}
          {videosByYear[item.year]?.src && (
            <section className={styles.videoSection}>
              <h2 className={styles.sectionTitle}>Rückblick {item.year} – Video</h2>
              <div className={styles.videoContainer}>
                <video
                  controls
                  className={styles.videoPlayer}
                >
                  <source src={videosByYear[item.year].src} type="video/mp4" />
                  Ihr Browser unterstützt das Video-Element nicht.
                </video>
              </div>
            </section>
          )}

          {/* Galerie */}
          {currentGalleryPhotos.length > 0 && (
            <section className={styles.gallerySection}>
              <h2 className={styles.sectionTitle}>Fotogalerie {item.year}</h2>
              <div className={styles.gallery}>
                {currentGalleryPhotos.map((photo) => (
                  <div 
                    key={photo.id} 
                    className={styles.galleryItem}
                    onClick={() => handlePhotoClick(photo, currentGalleryPhotos)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        handlePhotoClick(photo, currentGalleryPhotos);
                      }
                    }}
                  >
                    <img 
                      src={photo.src} 
                      alt={photo.alt}
                      className={styles.photo}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                ))}
              </div>
            </section>
          )}

          {/* Medienecho */}
          {currentMediaCoverage.length > 0 && (
            <section className={styles.gallerySection}>
              <h2 className={styles.sectionTitle}>Medienecho {item.year}</h2>
              <div className={styles.gallery}>
                {currentMediaCoverage.map((photo) => (
                  <div
                    key={photo.id}
                    className={styles.galleryItem}
                    onClick={() => handlePhotoClick(photo, currentMediaCoverage)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        handlePhotoClick(photo, currentMediaCoverage);
                      }
                    }}
                  >
                    <img
                      src={photo.src}
                      alt={photo.alt}
                      className={styles.photo}
                      loading="lazy"
                      decoding="async"
                    />
                  </div>
                ))}
              </div>
            </section>
          )}
        </article>
      ))}
    </section>
  );
}
